import { media, styled } from '@styles';
import { Container } from '@components/templates/Container';

export const Wrapper = styled(Container)`
  display: flex;
  margin: 0 auto;
  ${media.largeScreen`
    // max-width: 940px;
    // width: 74vw;
  `}
  ${media.mediumScreen`
    flex-direction: column;
    max-width: 350px;
  `}
  ${media.smallScreen`
    max-width: 272px;
  `}
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  ${media.largeScreen`
    width: 250px;
  `}
  ${media.mediumScreen`
    width: 100%;
  `}

  img {
    width: 100%;
  }

  a {
    font-family: ${(props) => props.theme.typography.boldFontFamily};
    font-size: ${(props) => props.theme.typography.baseFontSize};
    margin-top: 55px;
    line-height: 18px;
    text-transform: uppercase;
    width: 280px;
    text-align: center;
    ${media.largeScreen`
      line-height: 13px;
      margin-top: 36px;
      width: 220px;
    `}
    ${media.smallScreen`
      margin-top: 42px;
      width: 100%;
      max-width: 246px;
    `}
  }
`;

export const ItemTitle = styled.span`
  font-family: ${(props) => props.theme.typography.thinFontFamily};
  font-size: ${(props) => props.theme.typography.h4FontSize};
  line-height: 140%;
  margin-top: 60px;
  text-align: center;
  ${media.largeScreen`
    margin-top: 40px;
  `}
  ${media.smallScreen`
    margin-top: 20px;
  `}
`;

export const Separator = styled.div`
  width: 1px;
  margin-left: auto;
  margin-right: auto;
  background-color: ${(props) => props.theme.colors.secondary};
  opacity: 0.15;
  ${media.mediumScreen`
    width: 100%;
    height: 1px;
    margin-top: 50px;
    margin-bottom: 50px;
  `}
  ${media.smallScreen`
    margin-top: 25px;
    margin-bottom: 25px;
  `}
`;
